document.addEventListener("DOMContentLoaded", function() {
  /* Cart Sidebar */
  const cartOverlay = document.querySelector(".cart-overlay");
  const cartBackground = document.querySelector(".cart-background");
  const cartTexts = document.querySelectorAll(".cart-text");

  // Close sidebar when pressing Esc
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      cartOverlay.classList.remove("active");
    }
  });

  // Close sidebar when background is clicked
  cartBackground.addEventListener("click", function() {
    cartOverlay.classList.remove("active");
  });

  // close sidebar when X is clicked
  const cartClose = cartOverlay.querySelector(".close");
  cartClose.addEventListener("click", function() {
    cartOverlay.classList.remove("active");
  })

  // Open sidebar when cart text is clicked 
  for (let i = 0; i < cartTexts.length; i++) {
    cartTexts[i].addEventListener("click", function() {
      cartOverlay.classList.add("active");
    });
  }

  // Cart count
  const products = cartOverlay.querySelectorAll(".product");
  let currentCount = 0;
  for (let i = 0; i < products.length; i++) {
    const cartQuantity = products[i].querySelector(".cart-drawer-quantity-text");
    currentCount += parseInt(cartQuantity.innerHTML);
  }

  // Cart progress bars and circles
  const firstPart = cartOverlay.querySelector(".first-part .fill");
  const firstCircle = cartOverlay.querySelector(".first-circle");

  const secondPart = cartOverlay.querySelector(".second-part .fill");
  const secondCircle = cartOverlay.querySelector(".second-circle");

  const thirdPart = cartOverlay.querySelector(".third-part .fill");
  const thirdCircle = cartOverlay.querySelector(".third-circle");

  const fourthPart = cartOverlay.querySelector(".fourth-part .fill");
  const fourthCircle = cartOverlay.querySelector(".fourth-circle");

  // Update progress bar function
  function updateProgressBar(nextCount) {
    // current count 0
    if (currentCount == 0) {
      if (nextCount == 0) {
        return;
      }

      if (nextCount >= 1) {
        firstPart.style.width = "100%";

        setTimeout(() => {
          firstCircle.style.backgroundColor = "#ffdc73";
          firstCircle.style.border = "2px white solid";
        }, 400);
      }

      if (nextCount >= 2 ) {
        setTimeout(() => {
          secondPart.style.width = "100%";
        }, 400);

        setTimeout(() => {
          secondCircle.style.backgroundColor = "#ffdc73";
          secondCircle.style.border = "2px white solid";
        }, 800);
      }

      if (nextCount >= 3) {
        setTimeout(() => {
          thirdPart.style.width = "100%";
        }, 800);

        setTimeout(() => {
          thirdCircle.style.backgroundColor = "#ffdc73";
          thirdCircle.style.border = "2px white solid";
        }, 1200);
      }

      if (nextCount >= 4) {
        setTimeout(() => {
          fourthPart.style.width = "100%";
        }, 1200);

        setTimeout(() => {
          fourthCircle.style.backgroundColor = "#ffdc73";
          fourthCircle.style.border = "2px white solid";
        }, 1600);
      }
    }

    // current count 1
    else if (currentCount == 1) {
      if (nextCount == 0) {
        firstCircle.style.backgroundColor = "white";
        firstCircle.style.border = "2px #ffdc7 solid";

        firstPart.style.width = "0";
      }

      if (nextCount == 1) {
        return;
      }

      if (nextCount >= 2) {
        secondPart.style.width = "100%";
        setTimeout(() => {
          secondCircle.style.backgroundColor = "#ffdc73";
          secondCircle.style.border = "2px white solid";
        }, 400);
      }

      if (nextCount >= 3) {
        setTimeout(() => {
          thirdPart.style.width = "100%";
        }, 400);

        setTimeout(() => {
          thirdCircle.style.backgroundColor = "#ffdc73";
          thirdCircle.style.border = "2px white solid";
        }, 800);
      }

      if (nextCount >= 4) {
        setTimeout(() => {
          fourthPart.style.width = "100%";
        }, 800);

        setTimeout(() => {
          fourthCircle.style.backgroundColor = "#ffdc73";
          fourthCircle.style.border = "2px white solid";
        }, 1200);
      }
    }

    // current count 2
    else if (currentCount == 2) {
      if (nextCount <= 1) {
          secondCircle.style.backgroundColor = "white";
          secondCircle.style.border = "2px #ffdc73 solid";

          secondPart.style.width = "0";
      }
      if (nextCount <= 0) {
        setTimeout(() => {
          firstCircle.style.backgroundColor = "white";
          firstCircle.style.border = "2px #ffdc73 solid";

          firstPart.style.width = "0";
        }, 400);
      }

      if (nextCount == 2) {
        return;
      }

      if (nextCount >= 3) {
        thirdPart.style.width = "100%";

        setTimeout(() => {
          thirdCircle.style.backgroundColor = "#ffdc73";
          thirdCircle.style.border = "2px white solid";
        }, 400)
      }

      if (nextCount >= 4) {
        setTimeout(() => {
          fourthPart.style.width = "100%";
        }, 400)

        setTimeout(() => {
          fourthCircle.style.backgroundColor = "#ffdc73";
          fourthCircle.style.border = "2px white solid";
        }, 800)
      }
    }

    // current count 3 
    else if (currentCount == 3) {
      if (nextCount <= 2) {
        thirdCircle.style.backgroundColor = "white";
        thirdCircle.style.border = "2px #ffdc73 solid";

        thirdPart.style.width = "0";
      }
      if (nextCount <= 1) {
        setTimeout(() => {
          secondCircle.style.backgroundColor = "white";
          secondCircle.style.border = "2px #ffdc73 solid";

          secondPart.style.width = "0";
        }, 400)
      }
      if (nextCount <= 0) {
        setTimeout(() => {
          firstCircle.style.backgroundColor = "white";
          firstCircle.style.border = "2px #ffdc73 solid";

          firstPart.style.width = "0";
        }, 800)
      }

      if (nextCount == 3) {
        return;
      }

      if (nextCount >= 4) {
        fourthPart.style.width = "100%";

        setTimeout(() => {
          fourthCircle.style.backgroundColor = "#ffdc73";
          fourthCircle.style.border = "2px white solid";
        }, 400);
      }
    }

    // current count 4
    else if (currentCount >= 4) {
      if (nextCount >= 4) {
        return;
      }
      if (nextCount <= 3) {
        fourthCircle.style.backgroundColor = "white";
        fourthCircle.style.border = "2px #ffdc73 solid";

        fourthPart.style.width = "0";
      }
      if (nextCount <= 2) {
        setTimeout(() => {
          thirdCircle.style.backgroundColor = "white";
          thirdCircle.style.border = "2px #ffdc73 solid";

          thirdPart.style.width = "0";
        }, 400);
      }
      if (nextCount <= 1) {
        setTimeout(() => {
          secondCircle.style.backgroundColor = "white";
          secondCircle.style.border = "2px #ffdc73 solid";

          secondPart.style.width = "0";
        }, 800);
      }
      if (nextCount <= 0) {
        setTimeout(() => {
          firstCircle.style.backgroundColor = "white";
          firstCircle.style.border = "2px #ffdc73 solid";

          firstPart.style.width = "0";
        }, 1200);
      }
    }
  }

  function updateBundleText(nextCount) {
    const bundleText = cartOverlay.querySelector(".progress-container .text");

    if (nextCount >= 4) {
      bundleText.innerHTML = "Your bundle is ready";
    }
    else {
      const remainingCount = 4 - nextCount;
      let plural = "es"
      if (remainingCount == 1) {
        plural = "";
      }
      let text = `Add ${remainingCount} more box${plural} to checkout`;
      bundleText.innerHTML = text;
    }
  }

  function updateCheckoutButton(nextCount) {
    const checkoutForm = cartOverlay.querySelector("form");
    const quantityMessage = cartOverlay.querySelector(".quantity-message");

    if (nextCount >= 4) {
      checkoutForm.style.display = "flex";
      quantityMessage.style.display = "none";
    }
    else {
      checkoutForm.style.display = "none";
      quantityMessage.style.display = "flex";

      const remainingCount = 4 - nextCount;
      let plural = "es"
      if (remainingCount == 1) {
        plural = "";
      }
      let text = `Please add ${remainingCount} more box${plural} to checkout`;
      quantityMessage.innerHTML = text;
    }
  }

  function updateUI(updatedCart) {
    const totalCount = updatedCart.item_count;
    const subtotalPrice = updatedCart.items_subtotal_price / 100;

    updateProgressBar(totalCount);
    updateBundleText(totalCount);
    updateCheckoutButton(totalCount);

    const subtotalDiv = cartOverlay.querySelector(".subtotal-price");
    subtotalDiv.innerHTML = `$${subtotalPrice.toFixed(2)}`;

    currentCount = totalCount;
  }
 
  // Attach product event listeners
  for (let i = 0; i < products.length; i++) {
    attachProductEventListeners(products[i]);
  }

  function attachProductEventListeners(product) {
    const variantId = product.getAttribute("data-variant-id");
    
    // Trash listener
    const trashButton = product.querySelector(".trash-button");
    const trashLoading = product.querySelector(".trash-loading");
    trashButton.addEventListener("click", async function() {
      trashButton.style.display = "none";
      trashLoading.style.display = "block";

      const updatedCart = await removeVariantFromCart(variantId);
      updateUI(updatedCart);

      product.remove();
    })

    // Quantity listener
    const cartQuantitySteps = product.querySelectorAll(".cart-drawer-quantity-step");
    for (let i = 0; i < cartQuantitySteps.length; i++) {
      cartQuantitySteps[i].addEventListener("click", async function() {
        const quantityText = product.querySelector(".cart-drawer-quantity-text");
        const quantityLoading = product.querySelector(".cart-drawer-quantity-loading");
        let quantityNumber = parseInt(quantityText.innerHTML);

        quantityText.style.display = "none";
        quantityLoading.style.display = "block";

        // decrement
        if (this.classList.contains("decrement")) {
          quantityNumber--;
        }
        // increment
        else {
          quantityNumber++;
        }
        
        const updatedCart = await updateCartItemQuantity(variantId, quantityNumber);
        updateUI(updatedCart);

        const item = updatedCart.items.find(item => 
          item.id.toString() === variantId.toString() || 
          item.key === variantId.toString()
        );

        // If the item exists, get its quantity. If not (it was deleted), set to 0.
        const newVariantQuantity = item ? item.quantity : 0;
        
        if (newVariantQuantity == 0) {
          product.remove();
        }
        else {
          const finalLinePrince = item.final_line_price / 100;
          const priceDiv = product.querySelector(".price");
          priceDiv.innerHTML = `$${finalLinePrince.toFixed(2)}`;

          quantityText.innerHTML = newVariantQuantity;
          quantityText.style.display = "block";
          quantityLoading.style.display = "none";
        }
      });
    }
  }

  // Check if product page, then do add listener
  const addButton = document.querySelector(".product-page-add-to-cart-button");
  if (addButton) {
    const variantId = addButton.getAttribute("data-variant-id");

    const quantityProduct = document.querySelector("#Quantity-product");
    
    addButton.addEventListener("click", async function() {
      const quantityValue = quantityProduct.value;
    
      const addButtonText = addButton.querySelector(".text");
      const addButtonLoading = addButton.querySelector(".add-to-cart-loading");

      addButtonText.style.display = "none";
      addButtonLoading.style.display = "block";

      const updatedCart = await addItemToCart(variantId, quantityValue);
      
      const cartProduct = cartOverlay.querySelector(`.product[data-variant-id="${variantId}"]`)
      // if in cart, update quantity
      if (cartProduct) {
        // Logic for updating existing item
        const itemData = updatedCart.items.find(item => item.id.toString() === variantId.toString());
        if (itemData) {
          cartProduct.querySelector('.cart-drawer-quantity-text').innerHTML = itemData.quantity;
          cartProduct.querySelector('.price').innerHTML = `$${(itemData.final_line_price / 100).toFixed(2)}`;
        }
      } 
      else {
        // Find the new item data from the updated cart
        const newItem = updatedCart.items.find(item => item.id.toString() === variantId.toString());

        if (newItem) {
          const productContainer = cartOverlay.querySelector('.product-container');
        
          // Create the HTML string dynamically
          const productHtml = `
            <div class="product" data-variant-id="${newItem.id}">
              <div class="product-image-container">
                <img src="${newItem.image}" alt="${newItem.title}">
              </div>

              <div class="title-and-quantity-container">
                <div class="product-title">${newItem.product_title}</div>
                
                <div class="cart-drawer-quantity-container">
                    <div class="cart-drawer-quantity-step decrement" data-qty-change="decrement">–</div>
                    <div class="cart-drawer-quantity-number">
                        <div class="cart-drawer-quantity-text">${newItem.quantity}</div>
                        <img class="cart-drawer-quantity-loading" src="https://cdn.shopify.com/s/files/1/0774/8770/2230/files/loading.png?v=1770178583" style="display:none;">
                    </div>
                    <div class="cart-drawer-quantity-step increment" data-qty-change="increment">+</div>
                </div>
              </div>

              <div class="trash-and-price-container">
                  <img class="trash-button" src="https://cdn.shopify.com/s/files/1/0774/8770/2230/files/delete.webp?v=1770144312">
                  <img class="trash-loading" src="https://cdn.shopify.com/s/files/1/0774/8770/2230/files/loading.png?v=1770178583" style="display:none;">
                <div class="price" style="visibility: visible;">$${(newItem.final_line_price / 100).toFixed(2)}</div>
              </div>
            </div>
          `;

          // Insert the new product at the top of the container
          productContainer.insertAdjacentHTML('afterbegin', productHtml);
          const newlyAddedProduct = productContainer.firstElementChild;
          attachProductEventListeners(newlyAddedProduct);
        }
      }

      updateUI(updatedCart);

      cartOverlay.classList.add("active");

      addButtonText.style.display = "block";
      addButtonLoading.style.display = "none";
    });
  }

  /**
   * Removes all quantities of a variant and returns the updated cart object.
   * @param {number|string} variantId - The ID of the variant to remove.
   */
  async function removeVariantFromCart(variantId) {
    try {
      // Start both the fetch and a 1-second timer at the same time
      const [response] = await Promise.all([
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId.toString(),
            quantity: 0
          })
        }),
        new Promise(resolve => setTimeout(resolve, 1000)) // 1000ms minimum delay
      ]);

      if (!response.ok) {
        throw new Error('Failed to update cart');
      }

      const cart = await response.json();
      
      return cart;
    } catch (error) {
      console.error('Error removing item from cart:', error);
    }
  }

  /**
   * Updates a variant's quantity or removes it if quantity is 0.
   * Ensures the operation takes at least 1 second.
   * @param {number|string} variantId - The ID or Key of the item.
   * @param {number} quantity - The new quantity desired.
   */
  async function updateCartItemQuantity(variantId, quantity) {
    try {
      // Start the API call and the 1s timer simultaneously
      const [response] = await Promise.all([
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId.toString(),
            quantity: parseInt(quantity)
          })
        }),
        new Promise(resolve => setTimeout(resolve, 1000))
      ]);

      if (!response.ok) {
        throw new Error('Failed to update cart quantity');
      }

      const updatedCart = await response.json();
      
      return updatedCart;

    } catch (error) {
      console.error('Error updating cart:', error);
      return null;
    }
  }

  async function addItemToCart(variantId, quantity = 1) {
    try {
      const [response] = await Promise.all([
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: variantId.toString(),
              quantity: parseInt(quantity)
            }]
          })
        }),
        new Promise(resolve => setTimeout(resolve, 1000))
      ]);

      if (!response.ok) {
        throw new Error('Could not add item');
      }

      // After adding, we fetch the full cart object to return it
      const cartResponse = await fetch('/cart.js');
      const updatedCart = await cartResponse.json();
      
      return updatedCart;
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  }

  /* End Cart Sidebar */
});